import { render } from "./manage.vue?vue&type=template&id=3a4ca98a&scoped=true&ts=true"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=3a4ca98a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4ca98a"]])

export default __exports__